import apiClient from './apiClient';
import { cleanParams } from '@/utils/buildQuery';

const base = '/admin/banners';

export const bannersService = {
  list: (params) => apiClient.get(base, { params: cleanParams(params) }),
  create: (payload) => apiClient.post(base, payload),
  update: (id, payload) => apiClient.patch(`${base}/${id}`, payload),
  remove: (id) => apiClient.delete(`${base}/${id}`),

  // Artwork upload. Deliberately its own call: an editor picks the image once and then edits copy
  // and scheduling repeatedly without re-uploading it. Returns { stored, imageUrl, url } — store
  // `stored`/`imageUrl` on the banner (the backend keeps a RELATIVE path) and use `url` for the
  // preview. The Content-Type override is required: the shared axios instance defaults to JSON,
  // and axios only fills in the multipart boundary when it is allowed to.
  uploadImage: (file) => {
    const form = new FormData();
    form.append('file', file);
    return apiClient.post(`${base}/image`, form, { headers: { 'Content-Type': 'multipart/form-data' } });
  },

  // The carousel sequence is server-owned (the app renders in the order given and never sorts), so
  // reordering posts the WHOLE list in one call rather than patching one row's `order` — two rows
  // can never end up fighting over the same position.
  reorder: (ids) => apiClient.post(`${base}/reorder`, { order: ids }),
};

export default bannersService;
